import axiosInstance from "./api";
const cookies = require("js-cookie");
import config from "../config/index";

const setup = () => {
	axiosInstance.interceptors.request.use(
		(config) => {
			if (config.data instanceof FormData) {
				config.headers["Content-Type"] = "multipart/form-data";
			} else {
				// Assumes application/json for non-FormData payloads
				config.headers["Content-Type"] = "application/json";
			}
			let token = cookies.get("kyano_access_token");
			if (token) {
				config.headers["Authorization"] = "Bearer " + token; // for Spring Boot back-end
			}
			return config;
		},
		(error) => {
			return Promise.reject(error);
		}
	);

	axiosInstance.interceptors.response.use(
		(res) => {
			return res;
		},
		async (err) => {
			const originalConfig = err.config;
			if (originalConfig.url !== "/api/v1/login" && err.response) {
				// Access Token was expired
				if (err.response.status === 401) {

					// cookies.remove("kyano_access_token");
					// cookies.remove("kyano_user");
					// location.replace(config.url.main);
					return Promise.reject(err);
				}
			}
			return Promise.reject(err);
		}
	);
};

export default setup;